import React, { useRef, useState, useEffect } from 'react'
import { useFrame } from 'react-three-fiber'
import { useSpring, a } from '@react-spring/three'
import gsap from 'gsap'

const SphereShape = ({
  scale,
  position,
  animation,
  args,
  speed,
  factor,
  cover,
  delay,
}) => {
  const [expand, setExpand] = useState(false)
  const props = useSpring({
    scale: expand ? [0.7, 0.7, 0.7] : [0.6, 0.6, 0.6],
  })

  const sphereRef = useRef(null)
  useFrame(() => {
    sphereRef.current.rotation.y += 0.004
    // sphereRef.current.rotation.x += 0.004
    sphereRef.current.rotation.z += 0.004
  })

  const expandFunc = e => {
    let p = sphereRef.current.position
    // setExpand(!expand)
    gsap.to(p, {
      duration: 2.5,
      ease: 'power4.out',
      x: 2,
    })
  }

  const rotateFunc = () => {
    if (sphereRef.current) {
      let r = sphereRef.current.rotation
      let p = sphereRef.current.position
      const timeLine = gsap.timeline()
      timeLine.to(r, { duration: 5, ease: 'power4.out', x: 10 })
      timeLine.to(
        p,
        {
          duration: 5,
          ease: 'power4.out',
          x: 0.8,
        },
        '+='
      )
    }
  }

  const bounceFunc = () => {
    if (sphereRef.current) {
      const timeLine = gsap.timeline()
      let p = sphereRef.current.position
      let r = sphereRef.current.rotation
      timeLine
        .to(p, { duration: 2, ease: 'bounce.out', y: -1.2 })
        .to(r, { duration: 3.5, ease: 'power4.out', x: 10 }, '+=')
    }
  }

  const sphereAnimate = params => {
    const master = gsap.timeline()
    master.add(rotateFunc()).add(bounceFunc(), '-=2')
    // .add(conclusion(), "-=1")
  }

  const moveDropAnimation = params => {
    // stitch them together in a master timeline...
    const master = gsap.timeline()
    master.add(intro()).add(middle(), '>') //with a gap of 2 seconds
    // .add(conclusion(), '>') //overlap
  }

  const intro = () => {
    if (sphereRef.current) {
      const tl = gsap.timeline()
      let r = sphereRef.current.rotation
      let p = sphereRef.current.position
      tl.to(r, { duration: 3, ease: 'power4.out', x: 10 }).to(
        p,
        { duration: 3, ease: 'power4.out', x: 0.8 },
        '+='
      )
      return tl
    }
  }

  const middle = () => {
    if (sphereRef.current) {
      var tl = gsap.timeline()
      let p = sphereRef.current.position
      let r = sphereRef.current.rotation
      tl.to(p, { duration: 2, ease: 'bounce.out', y: -0.5 }).to(
        r,
        { duration: 1.8, ease: 'power4.out', x: 10 },
        '+='
      )
      return tl
    }
  }

  const conclusion = () => {
    if (sphereRef.current) {
      const tl = gsap.timeline()
      let r = sphereRef.current.rotation
      let p = sphereRef.current.position
      tl.to(p, { duration: 3, ease: 'power4.out', z: 0.1 }).to(
        r,
        { duration: 3, ease: 'power4.out', x: 10 },
        '+='
      )
      return tl
    }
  }

  useEffect(() => {
    if (sphereRef.current) {
      if (delay) {
        setTimeout(() => {
          if (animation) {
            sphereAnimate()
          } else {
            moveDropAnimation()
          }
        }, delay * 1000)
      }
    }
  }, [sphereRef.current])

  return (
    <a.mesh
      castShadow
      ref={sphereRef}
      scale={scale ? scale : props.scale}
      position={position}
      onClick={e => expandFunc(e)}
    >
      <sphereGeometry attach='geometry' args={args} />
      {/* <MeshWobbleMaterial
        attach='material'
        color={color}
        speed={speed}
        factor={factor}
        /> */}
      <meshStandardMaterial map={cover} attach='material' />
    </a.mesh>
  )
  // return (
  //   <div className='scene'>
  //     {/* <Canvas> */}
  //       <mesh ref={mesh}>
  //         <boxBufferGeometry attach='geometry' args={[1, 1, 1]} />
  //         <meshStandardMaterial attach='material' />
  //         {/* <circleBufferGeometry attach='geometry' args={[1, 360]} /> */}
  //         {/* <sphereGeometry attach='geometry' args={[1, 5, 5,5]} /> */}
  //       </mesh>
  //     {/* </Canvas> */}
  //   </div>
  // )
}

export default SphereShape
